import { BuilderContent } from '@builder.io/react'

import { CategoryBreadcrumb } from '@/components/CategoryBreadcrumb'
import { useBuilderState } from '@/hooks/useBuilderState'

function HeroBreadcrumb() {
  const { category } = useBuilderState()

  return (
    <BuilderContent
      model="category"
      content={category}
      options={{ includeRefs: true, query: { id: category?.id } }}
    >
      {(data) => <CategoryBreadcrumb category={data} />}
    </BuilderContent>
  )
}

export default HeroBreadcrumb
